import { render } from "./TempSavedImplantsHospital.vue?vue&type=template&id=07ec1a84&scoped=true"
import script from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"
export * from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"

import "./TempSavedImplantsHospital.vue?vue&type=style&index=0&id=07ec1a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ec1a84"]])

export default __exports__